import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateExternalTeacherBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const createExternalTeacher = createApiThunk<string, CreateExternalTeacherBody>(
  "educationalAdvisor/externalTeacher/create",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.createExternalTeacher(body);
  },
);

export const resetCreateExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetCreate");
